export const Colors = {
    dark: "#584b42",
    grey: "grey",
    orange: "#f77754",
    teal: "#537d91",
}
